import React, { useEffect, useRef, useState } from "react";
import {
  CalciteBlock,
  CalciteCheckbox,
  CalciteButton,
  CalcitePanel,
  CalciteSwitch,
} from "@esri/calcite-components-react";
// import '@esri/calcite-components/dist/components/calcite-checkbox';
import styles from "./ReleaseFilters.module.scss";
import switchStyles from "../CleanupsFilter/CleanupsFilter.module.scss";
import config from "../../assets/config.json";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils.js";

let paramArray: Array<any> = [];
let filteringIsSpecific: boolean = false;
let toggleOrClear: string = "clear";
let valuesLoaded: boolean = false;

const ReleaseFilters = (props: any) => {
  const [layerView, setLayerView] = useState<any>(null);
  const [hasWatchers, setHasWatchers] = useState<boolean>(false);
  const [signalAChange, setSignalAChange] = useState<number>(Math.random());
  // const [layer] = useState<any>(
  //   props.webmap.layers.find(
  //     (l) => l.title === config.layerNames.releases.title
  //   )
  // );
  const [layer] = useState<any>(
    props.webmap.layers.find(
      (e) => e.allLayers && e.allLayers.items.find(
        (p: any) => p.title === config.layerNames.releases.title
        )
    ).allLayers.items.find(
      (p: any) => p.title === config.layerNames.releases.title
      )
  );
  const checkboxGroups = useRef<Array<any>>([]);

  // get possible values for different categories to toggle sites by
  const getFieldValues = async (firstRender?: boolean) => {
    for (let i = 0; i < config.releaseFilterInfo.categories.length; i++) {
      let category: any = config.releaseFilterInfo.categories[i];
      if (!category.fieldValues && category.fieldName) {
        const result = await layer.queryFeatures({
          where: "1=1",
          returnDistinctValues: true,
          outFields: [category.fieldName],
        });
        const fieldValues: Array<any> = [];
        result.features.forEach((feature: any) => {
          fieldValues.push(feature.attributes[category.fieldName]);
        });
        category.fieldValues = fieldValues;
      }
    }
    valuesLoaded = true;
    if (firstRender) {
      buildInitialUI();
      if (props.customRouteUsed) toggleAll();
    }
  };

  const buildInitialUI = () => {
    const temp: Array<any> = [];
    for (let i = 0; i < config.releaseFilterInfo.categories.length; i++) {
      const sectionInfo = {
        title: config.releaseFilterInfo.categories[i].title,
        sectionCheckboxesDiv: buildUncheckedSection(
          config.releaseFilterInfo.categories[i]
        ),
      };
      temp.push(sectionInfo);
    }
    checkboxGroups.current = temp;
    // buildGroupsOfSections();
    setSignalAChange(Math.random());
  };

  // create sections for categories with unchecked boxes
  const buildUncheckedSection = (category: any) => {
    clearHasUIValues();
    const checkboxDivs: Array<any> = [];
    if (category.fieldValues) {
      category.fieldValues.forEach((value: string) => {
        const acronym = config.releaseAcronyms.find((a) => a.acronym === value);
        const label = acronym
          ? `${acronym.fullText} (${acronym.acronym})`
          : value;
        if (value !== null && value !== "") {
          checkboxDivs.push(
            <div className={styles.CheckboxAndLabelDivs} key={label}>
              <CalciteCheckbox
                name={value + " Box"}
                onCalciteCheckboxChange={() => {
                  toggleParam(category.fieldName, value);
                }}
              />
              <label className={styles.CheckboxLabels}>{label}</label>
            </div>
          );
          toggleParam(category.fieldName, value, undefined, true);
        }
      });
    } else if (category.fieldNames) {
      category.fieldNames.forEach((fieldName: any) => {
        // add proper labels for Oth_Unk and HazSub, otherwise make it fieldName
        let label = "";
        if (fieldName === config.othUnkValue)
          label = config.substanceOtherValue;
        else if (fieldName === config.hazSubValue) label = config.hazSubLabel;
        else label = fieldName;
        checkboxDivs.push(
          <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
            <CalciteCheckbox
              name={fieldName + " Box"}
              onCalciteCheckboxChange={() => {
                toggleParam(fieldName);
              }}
            />
            <label className={styles.CheckboxLabels}>{label}</label>
          </div>
        );
        toggleParam(fieldName, undefined, undefined, true);
      });
    }
    // returned item includes the check all checkbox, section label, and all of the checkboxes
    return (
      <div className={styles.sectionInHalves} key={Math.random()}>
        <CalciteCheckbox
          name={`${category.fieldName}-toggleAll`}
          onCalciteCheckboxChange={() => {
            checkSection(category);
          }}
          key={Math.random()}
        />
        <label className={styles.FilterSectionLabels}>{category.title}</label>
        <div className={styles.CheckboxSectionDivs}>{checkboxDivs}</div>
      </div>
    );
  };

  // create sections for categories with checked boxes
  const buildCheckedSection = (category: any) => {
    clearHasUIValues();
    const checkboxDivs: Array<any> = [];
    if (category.fieldValues) {
      category.fieldValues.forEach((value: string) => {
        const acronym = config.releaseAcronyms.find((a) => a.acronym === value);
        const label = acronym
          ? `${acronym.fullText} (${acronym.acronym})`
          : value;
        if (value !== null && value !== "") {
          checkboxDivs.push(
            <div className={styles.CheckboxAndLabelDivs} key={label}>
              <CalciteCheckbox
                checked
                name={value + " Box"}
                onCalciteCheckboxChange={() => {
                  toggleParam(category.fieldName, value);
                }}
              />
              <label className={styles.CheckboxLabels}>{label}</label>
            </div>
          );
          // ensure param is included in paramArray
          toggleParam(category.fieldName, value, true);
        }
      });
    } else if (category.fieldNames) {
      category.fieldNames.forEach((fieldName: any) => {
        // add proper labels for Oth_Unk and HazSub, otherwise make it fieldName
        let label = "";
        if (fieldName === config.othUnkValue)
          label = config.substanceOtherValue;
        else if (fieldName === config.hazSubValue) label = config.hazSubLabel;
        else label = fieldName;
        checkboxDivs.push(
          <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
            <CalciteCheckbox
              checked
              name={fieldName + " Box"}
              onCalciteCheckboxChange={() => {
                toggleParam(fieldName);
              }}
            />
            <label className={styles.CheckboxLabels}>{label}</label>
          </div>
        );
        // ensure param is included in paramArray
        toggleParam(fieldName, undefined, true);
      });
    }
    // returned item includes the check all checkbox, section label, and all of the checkboxes
    return (
      <div className={styles.sectionInHalves} key={Math.random()}>
        <CalciteCheckbox
          checked
          name={`${category.fieldName}-clearAll`}
          onCalciteCheckboxChange={() => {
            uncheckSection(category);
          }}
          key={Math.random()}
        />
        <label className={styles.FilterSectionLabels}>{category.title}</label>
        <div className={styles.CheckboxSectionDivs}>{checkboxDivs}</div>
      </div>
    );
  };

  // helper function to clear the hasUI property from the categories objects so the checkboxes can be rebuilt
  const clearHasUIValues = () => {
    config.releaseFilterInfo.categories.forEach((category: any) => {
      if (category.hasUI) category.hasUI = false;
    });
  };

  const checkSection = (category: any, togglingAll?: boolean) => {
    checkboxGroups.current.find(
      (group) => group.title === category.title
    ).sectionCheckboxesDiv = buildCheckedSection(category);
    // buildGroupsOfSections();
    // change is signaled in the toggleAll function if toggling all
    if (!togglingAll) setSignalAChange(Math.random());
  };

  const uncheckSection = (category: any, clearingAll?: boolean) => {
    checkboxGroups.current.find(
      (group) => group.title === category.title
    ).sectionCheckboxesDiv = buildUncheckedSection(category);
    // buildGroupsOfSections();
    // change is signaled in the clearAll function if clearing all
    if (!clearingAll) setSignalAChange(Math.random());
  };

  // helper function to add/remove query strings from the array
  const toggleParam = (
    fieldName: string,
    fieldValue?: string,
    forceAdd?: boolean,
    forceClear?: boolean
  ) => {
    const queryStr: string = fieldValue
      ? `(${fieldName} = '${fieldValue}')`
      : `(${fieldName} <> '' AND ${fieldName} <> 'FALSE')`;
    let temp: Array<any> = paramArray;
    // do the standard toggling if it is not an entire section being toggled
    if (!forceAdd && !forceClear) {
      if (!paramArray.find((s) => s === queryStr)) {
        temp.push(queryStr);
      } else {
        paramArray.length !== 1
          ? (temp = temp.filter(function (toCheck) {
              return toCheck !== queryStr;
            }))
          : (temp = []);
      }
    } else if (forceAdd && !forceClear) {
      // ensure that the param is in the array if adding entire section
      if (!paramArray.includes(queryStr)) {
        paramArray.push(queryStr);
      }
    } else if (!forceAdd && forceClear) {
      // ensure that the param is NOT in the array if clearing entire section
      paramArray.length !== 1
        ? (temp = temp.filter(function (toCheck) {
            return toCheck !== queryStr;
          }))
        : (temp = []);
    }
    paramArray = temp;
  };

  // clear all parameters and display no release sites on map
  const clearAll = () => {
    filteringIsSpecific = false;
    toggleOrClear = "clear";
    paramArray = [];
    clearHasUIValues();
    for (let i = 0; i < config.releaseFilterInfo.categories.length; i++) {
      let category: any = config.releaseFilterInfo.categories[i];
      uncheckSection(category);
    }
    filterLayer();
    setSignalAChange(Math.random());
  };

  // add all parameters and display all release sites on map
  const toggleAll = () => {
    filteringIsSpecific = false;
    toggleOrClear = "toggle";
    clearHasUIValues();
    for (let i = 0; i < config.releaseFilterInfo.categories.length; i++) {
      let category: any = config.releaseFilterInfo.categories[i];
      checkSection(category);
    }
    filterLayer(true);
    setSignalAChange(Math.random());
  };

  // set the LayerView filter property
  const filterLayer = (togglingAll?: boolean) => {
    let defStr = "";
    if (togglingAll) {
      defStr = "1=1";
    } else {
      filteringIsSpecific = true;
      if (paramArray.length > 0) {
        defStr = paramArray.join(" OR ");
        // layer.definitionExpression = defStr;
      } else {
        defStr = "1=0";
        // layer.definitionExpression = '1=1';
      }
    }
    layerView.filter = {
      where: defStr,
    };
    reactiveUtils.whenOnce(() => layerView.updating === false).then(() => {
      if (defStr !== "1=0") {
        layer.visible = true;
      } else {
        layer.visible = false;
      }
    });
  };

  useEffect(() => {
    if (!hasWatchers && layerView !== null) {
      reactiveUtils.when(
        () => layer.visible,
        () => {
          layerView.visible = true;
          if (filteringIsSpecific === false && valuesLoaded) {
            toggleAll();
          }
          filteringIsSpecific = false;
        }
      );
      reactiveUtils.when(
        () => !layer.visible,
        () => {
          layerView.visible = false;
          if (filteringIsSpecific === false && valuesLoaded) {
            clearAll();
          }
          filteringIsSpecific = false;
        }
      );
      setHasWatchers(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasWatchers, layerView]);

  useEffect(() => {}, [checkboxGroups, signalAChange]);

  useEffect(() => {
    if (layerView === null) {
      props.view.when(async () => {
        await props.view.whenLayerView(layer).then((featureLayerView) => {
          setLayerView(featureLayerView);
        });
      });
    }
  });

  // only triggered on the first render
  useEffect(() => {
    getFieldValues(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return valuesLoaded ? (
    <CalciteBlock
      open
      collapsible
      className={styles.ParentPanels}
      heading={"Release Filters"}
      description={"See filter options for release sites - please be sure to click the blue Filter button after making changes to the checkbox selections"}
    >
      <div className={switchStyles.controlsDiv}>
        <CalciteButton
          iconStart={"layer-filter"}
          onClick={() => {
            filterLayer();
          }}
        >
          Filter
        </CalciteButton>
        <div className={switchStyles.toggleSwitchDiv}>
          <label className={switchStyles.toggleLabel}>
            Toggle All Releases
          </label>
          {toggleOrClear === "toggle" && (
            <CalciteSwitch
              checked
              onCalciteSwitchChange={() => {
                clearAll();
              }}
            />
          )}
          {toggleOrClear === "clear" && (
            <CalciteSwitch
              onCalciteSwitchChange={() => {
                toggleAll();
              }}
            />
          )}
        </div>
      </div>
      <CalcitePanel>
        <div className={styles.SectionContainers}>
          {
            checkboxGroups.current.find((group) => group.title === "Substance")
              .sectionCheckboxesDiv
          }
          {
            checkboxGroups.current.find((group) => group.title === "Land Use")
              .sectionCheckboxesDiv
          }
        </div>
      </CalcitePanel>
      <CalcitePanel>
        <div className={styles.SectionContainers}>
          {
            checkboxGroups.current.find(
              (group) => group.title === "SPA Water Type"
            ).sectionCheckboxesDiv
          }
          {
            checkboxGroups.current.find(
              (group) => group.title === "SPA Facility Type"
            ).sectionCheckboxesDiv
          }
        </div>
      </CalcitePanel>
      <CalcitePanel>
        <label className={styles.FilterSectionLabels}>
          {"Well Head Protected Area (WHPA)"}
        </label>
        <div className={styles.SectionContainers}>
          {
            checkboxGroups.current.find((group) => group.title === "Water Type")
              .sectionCheckboxesDiv
          }
          {
            checkboxGroups.current.find(
              (group) => group.title === "Facility Type"
            ).sectionCheckboxesDiv
          }
        </div>
      </CalcitePanel>
    </CalciteBlock>
  ) : (
    <></>
  );
};
export default ReleaseFilters;
